import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import { Stack, TextStyle, Heading } from "@shopify/polaris";
import React from "react";
import { REPORT_TIKTOK_MANAGERS } from "../../../graphql/queries";
import { useReportsContext } from "../context";
import { CardBox } from "./CardBox";

const collapseKey = "TiktokManagerReport";


const getFlexStyle = (width, justify=null) => {
	let conf = {
		width,
		display: "inline-flex",
		wordWrap: "break-word",
	};
	if (justify) {
		conf["justify-content"] = justify;
	}
	return conf;
}


function TiktokManagerReport({ saleChanel }) {
	// Context
	const {
		range,
		isCompare,
		rangeToCompare,
		loading: loadingRoot,
		teamID,
		filter: filterCtx,
	} = useReportsContext();

	// State
	const [filter, setFilter] = React.useState({
		limit: 10,
		offset: 0,
		filterByTime: range,
		teamId: teamID,
	});
	const [state, setState] = React.useReducer((p, s) => ({ ...p, ...s }), {
		items: [],
		total: 0,
		compareTotal: 0,
		loading: true,
	});

	// Queries
	const { data, loading, error } = useQuery(REPORT_TIKTOK_MANAGERS, {
		variables: {
			filter,
		},
	});

	const [lazyReport, { data: d2, loading: l2, error: e2 }] = useLazyQuery(
		REPORT_TIKTOK_MANAGERS,
	);

	React.useEffect(() => {
		const mergedL = loading || l2 || loadingRoot;
		setState({ loading: mergedL });
	}, [loading, l2, loadingRoot]);

	React.useEffect(() => {
		setFilter((p) => ({
			...p,
			filterByTime: range,
			teamId: teamID ?? undefined,
		}));
	}, [range, teamID]);

	React.useEffect(() => {
		if (data?.getTiktokManagerReport == null) return;

		const items = data.getTiktokManagerReport?.nodes ?? [];
		const total = data.getTiktokManagerReport?.total ?? 0;
		setState({ items, total });
	}, [data]);

	React.useEffect(() => {
		if (!isCompare) return;
		let filterByTime = null;
		if (rangeToCompare?.from != null) {
			filterByTime = {
				...filter.filterByTime,
				...rangeToCompare,
			};
		}
		lazyReport({
			variables: {
				filter: {
					...filter,
					filterByTime,
				},
			},
		});
	}, [rangeToCompare, filter, isCompare]);

	// Markup
	const contentMarkup = React.useMemo(() => {
		const managers = state.items;

		return managers && managers.length > 0 ? (
				<>
					<div style={{marginTop: '10px'}}>
						<Stack wrap={false}>
							<span style={getFlexStyle('10rem')}>
								<TextStyle variation="strong"># ID</TextStyle>
							</span>
							<Stack.Item fill>
								<TextStyle variation="strong">Full name</TextStyle>
							</Stack.Item>
							<span style={getFlexStyle('11rem')}>
								<TextStyle variation="strong">Role</TextStyle>
							</span>
							<span style={getFlexStyle('5rem')}>
								<TextStyle variation="strong">Stores</TextStyle>
							</span>
							<span style={getFlexStyle('5rem')}>
								<TextStyle variation="strong">Pushed</TextStyle>
							</span>
							<span style={getFlexStyle('5rem')}>
								<TextStyle variation="strong">Orders</TextStyle>
							</span>
						</Stack>
					</div>

					<div style={{marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '15px'}}>
						{managers.map((item, key) => {
							return (
								<Stack
									key={`data-managers-${key}`}
									wrap={false}
								>
									<span style={getFlexStyle('10rem')}>
										{item?.id}
									</span>
									<Stack.Item fill>
										<strong>{item?.fullName}</strong>
									</Stack.Item>
									<span style={getFlexStyle('11rem')}>
										{item.teamRole}
										</span>
									<span style={getFlexStyle('5rem')}>
										{item.totalStores}
									</span>
									<span style={getFlexStyle('5rem')}>
										{item.totalPushedItems}
									</span>
									<span style={getFlexStyle('5rem')}>
										{item.totalOrders}
									</span>
								</Stack>
							)
						})}
					</div>
				</>
			)
			: null;
	}, [state.items]);

	console.log('Input filter: ', filter);

	return (
		<CardBox
			title="Tiktok Managers"
			headMarkup={null}
			contentMarkup={contentMarkup}
			filter={filter}
			loading={state.loading}
			error={error || e2}
			setFilter={setFilter}
			collapseKey={collapseKey}
			total={state.total}
			state={state}
		/>
	);
}

export { TiktokManagerReport };
